import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { isEmpty } from 'ramda'
import { Tooltip } from '@material-ui/core'

import { cnpj } from 'consts/regexp'
import { formatFilters } from 'services/utils'
import formatter from 'services/formatter'

import { Chip, SideBar, SearchFilter } from '@/components/index'
import { Trash } from '@/components/Icons'
import { getInventoryLogsRequest } from 'store/modules/admin/logs/reducer'
import { FormCombobox, FormDatePicker } from '@/components/CoForm'

// --------------- 𝕌𝕥𝕚𝕝𝕤 ---------------

const removeElem = (elem, previousState) =>
  [...previousState].filter((e) => JSON.stringify(e) !== JSON.stringify(elem))

// --------------- ℂ𝕠𝕞𝕡𝕠𝕟𝕖𝕟𝕥𝕤 ---------------

const StyledTrashIcon = styled(Trash)`
  margin-right: 20px;
  cursor: pointer;
  path {
    fill: ${(props) => props.theme.palette.primary.main};
  }
`

const initialFilters = {
  created_at: '',
  web_company_id: '',
  product_id: '',
  search_api_type: 'by_product',
}

const SEARCH_API_TYPE_OPTIONS = [
  { value: 'by_product', label: 'Consulta por produto' },
  { value: 'complete', label: 'Consulta geral' },
  { value: 'all', label: 'Ambas' },
]

const SEARCH_API_TYPE_LABELS = SEARCH_API_TYPE_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label
  return acc
}, {})

export default function Filter({
  onFiltering,
  loading,
  selectedFilters,
  resetPage,
  ...props
}) {
  const dispatch = useDispatch()

  const [filters, setFilters] = useState(initialFilters)

  const getLogs = useCallback(
    (filters) => {
      const { created_at, web_company_id, product_id, search_api_type } =
        filters

      dispatch(
        getInventoryLogsRequest({
          created_at,
          web_company_id,
          product_id,
          search_api_type,
        })
      )
    },
    [dispatch]
  )

  function handleDelete(filter) {
    const currentFilters = removeElem(filter, [...selectedFilters])

    const combinedFilters = {}
    currentFilters.forEach((filter) => {
      combinedFilters[filter.filterBy] = filter.value
    })

    setFilters((prev) => ({
      ...prev,
      [filter.filterBy]: initialFilters[filter.filterBy] || '',
    }))

    getLogs(combinedFilters)
    onFiltering(currentFilters)
  }

  function handleSubmit(values) {
    const rawDate = values.created_at

    const formatedDate = rawDate ? formatter(rawDate).toSimpleDate() : ''

    const cleanedFilters = {
      ...values,
      web_company_id: values.web_company_id?.replace(/\D/g, ''),
      created_at: rawDate,
    }

    setFilters(cleanedFilters)

    const backendFilters = {
      ...cleanedFilters,
      created_at: formatedDate,
    }

    onFiltering(formatFilters(backendFilters))
    getLogs(backendFilters)
    resetPage()
  }

  function handleClearFilters() {
    setFilters(initialFilters)
    onFiltering([])
    getLogs(initialFilters)
  }

  function SelectSearchAPIType() {
    return (
      <FormCombobox
        disableClearble
        name="search_api_type"
        label="Tipo consulta"
        variant="filled"
        options={SEARCH_API_TYPE_OPTIONS}
      />
    )
  }

  return (
    <SideBar
      {...props}
      loading={loading}
      HeaderComponent={
        !isEmpty(selectedFilters) ? (
          <div className="ChipList ChipListSpacing">
            {selectedFilters.map((filter, index) => {
              let label = filter.value
              if (filter.filterBy === 'search_api_type') {
                label = SEARCH_API_TYPE_LABELS[filter.value] || filter.value
              }

              return (
                <Chip
                  onDelete={() => handleDelete(filter)}
                  label={label}
                  key={index}
                />
              )
            })}
            <Tooltip title="Excluir filtros">
              <div>
                <StyledTrashIcon onClick={handleClearFilters} />
              </div>
            </Tooltip>
          </div>
        ) : null
      }
      ContentComponent={
        <SearchFilter
          onSubmit={handleSubmit}
          inline={false}
          initialData={filters}
          title="Pesquisar por"
          buttonLabel="Buscar"
          fields={[
            {
              name: 'search_api_type',
              label: 'Tipo consulta',
              Component: SelectSearchAPIType,
            },
            {
              name: 'created_at',
              label: 'Data',
              Component: FormDatePicker,
            },
            {
              name: 'product_id',
              label: 'Código do Produto',
            },
            {
              name: 'web_company_id',
              label: 'CNPJ',
              textMaskProps: { mask: cnpj.array },
            },
          ]}
        />
      }
    />
  )
}
